import { UserMediaDevicePlatformError } from '@openphone/desktop-client'

import type Permissions from '@src/permissions/Permissions'

import UMDAPlatformStrategy from './UMDAPlatformStrategy'

export default class UMDAWebStrategy extends UMDAPlatformStrategy {
  constructor(private readonly permissions: Permissions) {
    super('web')
  }

  async hasMicrophoneAccess() {
    const status = await this.permissions.query('microphone')
    if (status === 'denied') {
      return new UserMediaDevicePlatformError(
        {
          mediaDevice: 'microphone',
          platform: this.platform,
          originalError: new Error('Microphone access denied'),
        },
        'denied',
      )
    }
    return true
  }
}
